import { render, staticRenderFns } from "./snsJoinForm.vue?vue&type=template&id=5e053b0e&scoped=true"
import script from "./snsJoinForm.vue?vue&type=script&lang=js"
export * from "./snsJoinForm.vue?vue&type=script&lang=js"
import style0 from "./snsJoinForm.vue?vue&type=style&index=0&id=5e053b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e053b0e",
  null
  
)

export default component.exports